import React from "react";
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import Store from './Store';
import { Provider } from 'react-redux';

import "leaflet/dist/leaflet.css";
// Provide Redux store from top most parent so that all redux state variables can be accessible by all components

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}


const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <App/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
